import { Heuristic } from '../../jscaip/AI/Heuristic';
import { PenteRules } from './PenteRules';
export class PenteAlignmentHeuristic extends Heuristic {
    getBoardValue(node, config) {
        return PenteRules
            .get()
            .getHelper(config)
            .getBoardValue(node.gameState);
    }
}
